import script from "./PushCampaignMixin.vue?vue&type=script&lang=ts"
export * from "./PushCampaignMixin.vue?vue&type=script&lang=ts"

export default script